import _ from "lodash";
import { API_ROUTES } from "@/constants/apiRoutes";
import { httpRequestServer } from "@/services/httpRequestServer";
import { ISharedLinkPostRequest, ISharedLinkInsertRequest, ISharedLinkResponse } from "@/models/sharedLink.model";

export const sharedLinkDataService = {
  insertAsync: async (request: ISharedLinkInsertRequest) : Promise<ISharedLinkResponse> => {
    return await httpRequestServer.post(`${API_ROUTES.SHARED_LINK}/insert`, request);
  },  
  postAsync: async (request: ISharedLinkPostRequest) : Promise<ISharedLinkResponse> => {
    return await httpRequestServer.post(`${API_ROUTES.SHARED_LINK}/post`, request);
  },
};